"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.h5PcBridgeInit = void 0;
var h5PcBridgeInit = function () {
    // to make bridge script run first, to avoid conflict with DingTalkPC.js (old pc jsapi script)
    return Promise.resolve(require('../packages/frame-talk-client-pc/index.js'));
};
exports.h5PcBridgeInit = h5PcBridgeInit;
var h5PcBridge = function (method, params) {
    return new Promise(function (resolve, reject) {
        var frameTalkClient = require('../packages/frame-talk-client-pc/index.js');
        var RequestMsg = frameTalkClient.invokeAPI(method, params);
        return RequestMsg.result.then(function (data) {
            // compatibility
            if (typeof params.onSuccess === 'function') {
                params.onSuccess.call(null, data);
            }
            return resolve(data);
        }, function (err) {
            // compatibility
            if (typeof params.onFail === 'function') {
                params.onFail.call(null, err);
            }
            return reject(err);
        });
    });
};
exports.default = h5PcBridge;
